import { type ReduxStateShared } from '~shared/types';

const getUiUsers = (state: ReduxStateShared) => state.ui.users;

export const getSelectedUserID = (state: ReduxStateShared) => state.ui.users.selectedUserID;
export default getUiUsers;
